export default __webpack_public_path__ + "static/media/transparentArtie.11a793ac.png";